import React from 'react';
import * as S from './styled';

const Banner = ({
  children,
  title,
  subtitle,
  bold = true,
  className,
  ...rest
}) => (
  <S.Banner {...rest} className={`Banner ${className}`}>
    {title && <S.BannerTitle subtitle={subtitle}>{title}</S.BannerTitle>}
    {subtitle && <S.BannerSubtitle bold={bold}>{subtitle}</S.BannerSubtitle>}
    {children}
  </S.Banner>
);

export default Banner;
